const createPopup = (self, daysEl) => {
  if (!self.popups)
    return;
  Object.keys(self.popups).forEach((date) => {
    var _a;
    const dayBtnEl = daysEl.querySelector(`[data-calendar-day="${date}"]`);
    if (dayBtnEl) {
      const dayInfo = (_a = self.popups) == null ? void 0 : _a[date];
      if (dayInfo == null ? void 0 : dayInfo.modifier)
        dayInfo.modifier.trim().split(" ").forEach((cl) => {
          dayBtnEl.classList.add(cl);
        });
      if (dayInfo == null ? void 0 : dayInfo.html)
        dayBtnEl.parentNode.innerHTML += `<div class="${self.CSSClasses.dayPopup}">${dayInfo.html}</div>`;
    }
  });
};
export {
  createPopup as default
};
